import * as React from "react";

import primaryColour from "../../constants";

interface DirectionArrowProps extends React.SVGProps<SVGSVGElement> {
  rotation?: number;
}

function SvgDirectionArrow(props: DirectionArrowProps): React.ReactElement {
  const { fill = primaryColour, rotation = 0 } = props;
  return (
    <svg width={25} height={20} viewBox="0 0 25 20" fill="none" {...props}>
      <path
        d="M0.5 19.5L13 0.5L24.5 19.5L13 14L0.5 19.5Z"
        fill={fill}
        style={{ transform: `rotate(${rotation}deg`, transformBox: "fill-box", transformOrigin: "center" }}
      />
    </svg>
  );
}

export default SvgDirectionArrow;
